import { useState } from 'react';
import { Button, Icon } from '@nazka/nazka.mapframe.components';
import { faArrowLeft, faShareNodes } from '@fortawesome/pro-light-svg-icons';
import { useNavigate, Link, useParams } from 'react-router-dom';

import SharePopup from '@App/components/SharePopup/SharePopup';
import ItemNotFound from '@App/components/ItemNotFound/ItemNotFound';
import ImageWithFallback from '@App/components/ImageWithFallback/ImageWithFallback';

import { getImageUrl } from '@services/utils.service';
import { HAZARD_CATEGORIES } from '@App/components/AdaptationListComponent/adaptation-list-component.constants';
import { usePublishedAdaptationStories } from '@services/query.service';
import { useTranslation } from '@utils/i18n/i18n.consumers';

import MapMarkerLayer from '../MapMarkerLayer/MapMarkerLayer';

import './story-detail.styl'

function StoryDetail() {
  const { t } = useTranslation();
  const [showSharePopup, setShowSharePopup] = useState(false);

  const navigate = useNavigate()
  const { data: adaptationStories = [], isLoading } = usePublishedAdaptationStories();
  const { id } = useParams();

  const adaptationStory = adaptationStories?.find(story => story.id === id);

  if (!isLoading && !adaptationStory) {
    return <ItemNotFound goBack={() => navigate('/adaptation/stories')} />;
  }

  return (
    <div className="story-detail">
      <div className="story-detail__header">
        <ImageWithFallback
          className="story-detail__img"
          src={getImageUrl(adaptationStory)}
          fallbackSrc="/img/story-placeholder.png"
          alt=""
        />
        <div className="story-detail__header__content">
          <h3>{adaptationStory?.translations?.en?.title}</h3>
          <span className="story-detail__category">{t('Story')}</span>
        </div>
      </div>

      <div className="story-detail__location">
        <span className="story-detail__location__title">
          {t('Address')}
          :
        </span>
        <span>{adaptationStory?.address}</span>
      </div>
      <div className="story-detail__hazard">
        <span className="story-detail__hazard__title">{t('Hazard category')}</span>
        <div className="story-detail__hazard__names-wrapper">
          {adaptationStory?.hazardCategories.map((hazardCategory) => {
            const hazard = HAZARD_CATEGORIES.find(h => h.id === hazardCategory);
            return hazard ? (
              <span className="story-detail__hazard__name" key={hazard.id}>
                <Icon icon={hazard.icon} size="24px" />
                {t(hazard.id)}
              </span>
            ) : null;
          })}
        </div>

      </div>
      <div className="story-detail__description">
        <span className="story-detail__description__title">{t('What did you manage to adapt and how does it address the hazard?')}</span>
        <p>{adaptationStory?.translations?.en?.description}</p>
      </div>
      {adaptationStory?.linkedPlan && (
        <div className="story-detail__action-plan">
          <span className="story-detail__action-plan__title">{t('Linked plan')}</span>
          <Link to={`/adaptation/plans/${adaptationStory?.linkedPlan}`}>{adaptationStory?.linkedPlanTitle.en}</Link>
        </div>
      )}
      <div className="story-detail__challenges">
        <span className="story-detail__challenges__title">{t('Who is responsible')}</span>
        <p>{adaptationStory?.responsible}</p>
      </div>
      <div className="story-detail__cta">
        <Button
          icon={faArrowLeft}
          css={{
            borderRadius: '10px',
            flexDirection: 'row-reverse',
            '&:hover': {
              color: 'white',
              backgroundColor: '#72A276',
            },
          }}
          onClick={() => navigate('/adaptation/stories')}
          layout="outlined"
        >
          {t('Go back')}
        </Button>
        <Button
          icon={faShareNodes}
          css={{
            borderRadius: '10px',
            color: 'white',
            flexDirection: 'row-reverse',
            '&:hover': {
              color: 'white',
            },
          }}
          onClick={() => setShowSharePopup(`${window.location.origin}/adaptation/stories/${adaptationStory?.id}`)}
        >
          {t('Share')}
        </Button>
      </div>
      <MapMarkerLayer markerData={[adaptationStory]} setSelectedMarker={() => {}} selectedMarker={null} isSingle />
      {showSharePopup && (
        <SharePopup
          qrCodeText={showSharePopup}
          onClose={() => setShowSharePopup(false)}
        />
      )}
    </div>
  )
}

export default StoryDetail